import TextInputWithInlineLabel from '../TextInputWithInlineLabel.jsx';

const ExpirationInput = ({ value, onChange }) => {
    const hasExpiration = value?.expires >= 0;
    return (
        <div className="pl-6 flex-1">
            <div className="py-3">
                <label className="flex items-center gap-x-4">
                    <input
                        type="radio"
                        checked={hasExpiration}
                        onChange={ev =>
                            ev.target.checked && onChange({ expires: 30 })
                        }
                    />
                    Expires after
                </label>
                {hasExpiration && (
                    <TextInputWithInlineLabel
                        className="max-w-48 ml-8"
                        inputClassName="pr-12"
                        label=""
                        autoFocus={value?.expires === '30'}
                        value={value?.expires || ''}
                        onChange={newValue => onChange({ expires: newValue })}
                        type="number"
                        suffix={<span className="text-gray-500">days</span>}
                    />
                )}
            </div>
            <label className="py-3 border-t flex items-center gap-x-4">
                <input
                    type="radio"
                    checked={!hasExpiration}
                    onChange={ev =>
                        ev.target.checked && onChange({ expires: -1 })
                    }
                />
                No expiration
            </label>
        </div>
    );
};

export default ExpirationInput;
